import { Injectable } from '@angular/core';
import { HttpUtilityService } from './http-utility.service';
import { apiEndpoints } from '../constants/api-endpoints';
import { map, Observable } from 'rxjs';
import {
  CrewWeeklyRequest,
  CrewWeeklyResponse,
} from '../interface/CrewWeeklyDetails';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CrewWeeklyService {
  constructor(private readonly httpUtilityService: HttpUtilityService) {}

  public getCrewWeeklyReport(
    data: CrewWeeklyRequest
  ): Observable<CrewWeeklyResponse | null> {
    const url = apiEndpoints.weeklyScheduleDrill;
    return this.httpUtilityService
      .post<HttpResponse<CrewWeeklyResponse | null>>(url, data, {
        observe: 'response',
      })
      .pipe(
        map((res: HttpResponse<CrewWeeklyResponse | null>) => {
          return res.body || null;
        })
      );
  }
}
